import { GraphQLClient } from 'graphql-request';
import { getSdk, RamcoMemberContactInput, UpdateRamcoContactInput } from '../generated/client';

interface GetMembersParams {
    pageSize: number
    search?: string | null,
    next?: boolean
    previous?: boolean
}

interface GetEventsParams {
    pageSize: number
    next?: boolean
    previous?: boolean
}

export function Turnstile(associationId: string) {

    this.associationId = associationId
    this.jwt = null
    let params = new URLSearchParams(document.location.search);
    let jwt = params.get("jwt")
    this.membersStartCursor = null
    this.membersEndCursor = null
    this.membersSearchQuery = null
    this.cursors = {}

    if (jwt) {
        this.jwt = jwt
        sessionStorage.setItem('TURNSTILE_USER_JWT', jwt);
        params.delete("jwt")
        window.history.replaceState({}, document.title, window.location.pathname + (params.toString() != "" ? "?" + params.toString() : ""));
    } else {
        if (sessionStorage.getItem('TURNSTILE_USER_JWT')) {
            this.jwt = sessionStorage.getItem('TURNSTILE_USER_JWT')
        }
    }

    const client = new GraphQLClient('https://api.rialtoturnstile.com/graphql', {
        headers: {
            authorization: this.jwt ? `Bearer ${this.jwt}` : null,
        },
    })

    const sdk = getSdk(client)
    const self = this;


    this.getMember = async function (memberId: string) {
        return await sdk.Member({ memberId: memberId })
    }

    this.getOffice = async function (officeId: string) {
        return await sdk.Office({ officeId: officeId })
    }

    this.getMembers = async function ({ pageSize, search = null, next, previous }: GetMembersParams) {

        //this.membersSearchQuery = (search != null && search != '') ? search : null

        let queryParams = {
            associationId: this.associationId,
            first: pageSize
        }
        if (search) {
            queryParams['query'] = search
        }

        if (next && this.cursors['membersEndCursor']) {
            queryParams['after'] = this.cursors['membersEndCursor']
            queryParams['first'] = pageSize
            delete queryParams['last']
        }

        if (previous && this.cursors['membersStartCursor']) {
            queryParams['before'] = this.cursors['membersStartCursor']
            queryParams['last'] = pageSize
            delete queryParams['first']
        }

        let data = await sdk.Members(queryParams)
        let pageInfo = data?.members?.pageInfo
        this.cursors['membersStartCursor'] = pageInfo?.startCursor
        this.cursors['membersEndCursor'] = pageInfo?.endCursor

        return {
            members: data?.members?.nodes,
            hasNextPage: pageInfo?.hasNextPage,
            hasPreviousPage: pageInfo?.hasPreviousPage,
        }
    }

    this.getNextMembers = async function ({ pageSize,search }: GetMembersParams) {
        return self.getMembers({ pageSize: pageSize, next: true,previous: false, search })
    }

    this.getPreviousMembers = async function ({ pageSize,search }: GetMembersParams) {
        return self.getMembers({ pageSize: pageSize, previous: true, next: false, search })
    }

    this.getCurrentUser = async function () {
        let user = await sdk.CurrentUser()
        return user.currentUser
    }
    this.getEvents = async function ({ pageSize, next, previous }: GetEventsParams) {

        let queryParams = {
            associationId: this.associationId,
            first: pageSize
        }
        if (next && this.cursors['calendarEndCursor']) {
            queryParams['after'] = this.cursors['calendarEndCursor']
            queryParams['first'] = pageSize
        }

        if (previous && this.cursors['calendarStartCursor']) {
            queryParams['before'] = this.cursors['calendarStartCursor']
            queryParams['last'] = pageSize
        }

        let data = await sdk.CalendarItems(queryParams)
        let pageInfo = data?.calendarItems?.pageInfo
        this.cursors['calendarStartCursor'] = pageInfo?.startCursor
        this.cursors['calendarEndCursor'] = pageInfo?.endCursor

        return {
            events: data?.calendarItems?.nodes,
            hasNextPage: pageInfo?.hasNextPage,
            hasPreviousPage: pageInfo?.hasPreviousPage,
        }
    }

    this.getNextEvents = async function ({ pageSize }: GetEventsParams) {
        return self.getEvents({ pageSize: pageSize, next: true })
    }

    this.getPreviousEvents = async function ({ pageSize }: GetEventsParams) {
        return self.getEvents({ pageSize: pageSize, previous: true })
    }

    this.updateProfile = async function (profile: RamcoMemberContactInput) {
        return await sdk.UpdateContact({ 
            input: {
                input: profile
            }
         })
    }

    this.login = async function () {
        let data = await sdk.Login({
            input: {
                associationId: associationId,
                redirectUrl: `${window.location.origin}${window.location.pathname}`
            }
        })
        location.href = data.ssoLogin.redirectUrl
    }
}